import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { IProduct, IProductForm, productFromJson, productToJson } from "./entities";

interface IProductRepo extends ICRUDRepo<IProduct, IProductForm> {}

const URL = "v1/product";

const ProductRepoImplFactory = (apiClient: ApiClient): IProductRepo => {
  const r: IProductRepo = {
    ...generateCrudRepoFactory<IProduct, IProductForm>(apiClient, URL, productFromJson, productToJson),
  };

  return r;
};

export const ProductRepoImpl = ProductRepoImplFactory(apiClient);
